import { ActionEffectType } from '@televet/shared-types/JsonTypes/WorkflowEventActionConfig';
import { WorkflowEventAction } from 'shared/types/graphql';
import { TypedAutomationSetting, TypedAutomationSettingButtonEffect } from '../../../types';

// Creates a curried updater to modify the assigneeIds of the CreateTask effect for the given button within a workflow action.
// This helps to avoid several iterations on the nested JSON object
export const createCurriedAssigneeUpdater = (
  workflowAction: Partial<WorkflowEventAction>,
  config: TypedAutomationSetting['actions'][number]['config'],
  updatedButtonData: TypedAutomationSettingButtonEffect,
) => {
  return (finalAssigneeList: string[]): Partial<WorkflowEventAction> => ({
    ...workflowAction,
    config: {
      ...config,
      buttons: config.buttons.map((button) =>
        button === updatedButtonData
          ? {
              ...button,
              actionEffects: button.actionEffects.map((effect) =>
                effect.type === ActionEffectType.CreateTask ? { ...effect, assigneeIds: finalAssigneeList } : effect,
              ),
            }
          : button,
      ),
    },
  });
};
